import { map } from 'lodash'
import { error } from '@/utils/alert'
import bus from '@/utils/eventBus'

export default {
  doAbsentAll () {
    const ids = map(this.schedules, schedule => {
      return schedule.id
    })

    this.$resource.put(ids.toString() + '/absent')
      .then(({data}) => {
        bus.$emit('is-absent', {show: true})
        this.$emit('close', data)
      })
      .catch(() => {
        error('Ocorreu um erro ao confirmar este horário.')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/components/absent/resources/methods.js